// Export van de ledenadministratie. Puur: krijgt de rijen, levert een zip.
// Formaat uit het implementatieplan: JSON per tabel, CSV van de hoofdtabel en
// een manifest met schemaversie en aantallen. Geen export in het formaat van
// een ander pakket: een open formaat plus de schrijf-API is wat een derde
// nodig heeft om zelf te vertalen.
import { zipSync, strToU8 } from 'fflate';

export const SCHEMAVERSIE = '2026-09-25.1';

const CSV_KOLOMMEN = [
  'id', 'lidnummer', 'voornaam', 'tussenvoegsel', 'achternaam', 'geboortedatum', 'geslacht',
  'email', 'telefoon', 'straat', 'huisnummer', 'postcode', 'plaats', 'land', 'nationaliteiten',
  'trainingsgroep', 'graad_opgave', 'notities', 'created_at', 'updated_at',
];

// Een cel die met = + - @ begint, voert een spreadsheet uit als formule. Dat
// is een bekende aanvalsroute via geëxporteerde bestanden; een apostrof ervoor
// maakt er weer tekst van.
function csvCel(v) {
  if (v === null || v === undefined) return '';
  let s = Array.isArray(v) ? v.join(' ') : String(v);
  if (/^[=+\-@\t\r]/.test(s)) s = `'${s}`;
  return /[";,\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function naarCsv(rijen, kolommen = CSV_KOLOMMEN) {
  const regels = [kolommen.join(';'), ...rijen.map(r => kolommen.map(k => csvCel(r[k])).join(';'))];
  return '﻿' + regels.join('\r\n') + '\r\n';
}

// tabellen: { persons, person_relations, guardianships, consents, person_passports? }
export function bouwExport({ organisatie, gemaaktDoor, tabellen, soort = 'leden', nu = new Date() }) {
  const bestanden = {};
  const aantallen = {};
  for (const [naam, rijen] of Object.entries(tabellen)) {
    if (!rijen) continue;
    bestanden[`${naam}.json`] = strToU8(JSON.stringify(rijen, null, 2));
    aantallen[naam] = Array.isArray(rijen) ? rijen.length : 1;
  }
  bestanden['persons.csv'] = strToU8(naarCsv(tabellen.persons || []));
  const manifest = {
    schema_versie: SCHEMAVERSIE,
    soort,
    organisatie: { id: organisatie.id, naam: organisatie.name || organisatie.naam || null },
    gemaakt_op: nu.toISOString(),
    gemaakt_door: gemaaktDoor,
    aantallen,
    bestanden: Object.keys(bestanden).sort(),
    met_paspoorten: !!tabellen.person_passports,
  };
  bestanden['manifest.json'] = strToU8(JSON.stringify(manifest, null, 2));
  return { zip: zipSync(bestanden, { level: 6 }), manifest };
}

export function bestandsnaam(organisatie, nu = new Date(), voorvoegsel = 'leden') {
  // De naam, niet de oude slug: die klopt na een naamswijziging niet meer.
  const slug = String(organisatie.name || organisatie.naam || organisatie.slug || 'organisatie').toLowerCase()
    .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  return `${voorvoegsel}-${slug}-${nu.toISOString().slice(0, 10)}.zip`;
}
